<div class="malou-spin--{{ size() }}">
    <mat-icon
        class="malou-spin malou-spin--{{ size() }}"
        color="primary"
        [svgIcon]="SvgIcon.SPINNER"
        [ngStyle]="color() ? { color: color() } : {}"></mat-icon>
</div>
